export default "__VITE_ASSET__tElsRS5y__"